import type { IconSvgObject } from './types';

const Summation02Icon: IconSvgObject = [
  ["path", { d: "M18.5 3L20 3.00001C21.1046 3.00002 22 3.89545 22 5.00001V19C22 20.1046 21.1046 21 20 21H18.5M5.5 21H4C2.89543 21 2 20.1046 2 19V5C2 3.89543 2.89543 3 4 3H5.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M15 9.5V8H9L12.5 12L9 16H15V14.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default Summation02Icon;
